import React from "react";
import { Card } from "../core/Card";
import { Badge } from "../core/Badge";
import { Button } from "../core/Button";
import { Icon } from "../core/Icon";

export function JobCard({
  title, category, city, state, budgetMin, budgetMax, postedAt,
  locationLabel, budgetLabel,
  quotesCount, status, photoUrl, ctaLabel = "Send a quote", onAction,
}) {
  const statusTone = { open: "success", quoted: "gold", hired: "trust", closed: "neutral" }[status] || "neutral";
  return (
    <Card interactive padding="md">
      <div style={{ display: "flex", gap: "var(--space-3)", flexWrap: "wrap" }}>
        {photoUrl && (
          <img src={photoUrl} alt="" style={{
            width: "clamp(64px, 12vw, 84px)", height: "clamp(64px, 12vw, 84px)", flex: "0 0 auto", objectFit: "cover",
            borderRadius: "var(--radius-md)", background: "var(--sand)",
          }} />
        )}
        <div style={{ minWidth: 180, flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "var(--space-2)", flexWrap: "wrap" }}>
            {status && <Badge tone={statusTone}>{status}</Badge>}
            <span style={{ fontSize: "var(--text-xs)", color: "var(--text-subtle)" }}>{category}</span>
          </div>
          <h3 style={{
            marginTop: 6, fontFamily: "var(--font-display)", fontWeight: "var(--weight-bold)",
            fontSize: "var(--text-lg)", color: "var(--text-body)", lineHeight: "var(--leading-tight)",
          }}>{title}</h3>
          <div style={{
            display: "flex", gap: "var(--space-4)", flexWrap: "wrap", marginTop: "var(--space-2)",
            fontSize: "var(--text-xs)", color: "var(--text-muted)",
          }}>
            {/* No data, no orphan icon. A lone pin followed by ", " does not
                read as "location unknown", it reads as a broken page. */}
            {(locationLabel || city || state) && (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                <Icon name="map-pin" size={11} />
                {locationLabel || `${city || ""}${city && state ? ", " : ""}${state || ""}`}
              </span>
            )}
            {/* $0 is the absence of a budget, not a budget. Callers that can
                translate pass `budgetLabel`; the rest simply show nothing. */}
            {(budgetLabel || Number(budgetMin) > 0 || Number(budgetMax) > 0) && (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontFamily: "var(--font-mono)" }}>
                <Icon name="wallet" size={11} />
                {budgetLabel || `$${budgetMin}–$${budgetMax}`}
              </span>
            )}
            {postedAt && (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                <Icon name="clock" size={11} />{postedAt}
              </span>
            )}
          </div>
        </div>
      </div>
      <div style={{
        marginTop: "var(--space-4)", paddingTop: "var(--space-3)",
        borderTop: "1px solid var(--border-default)", display: "flex",
        alignItems: "center", justifyContent: "space-between", gap: "var(--space-2)",
      }}>
        <span style={{ fontFamily: "var(--font-mono)", fontSize: "var(--text-xs)", color: "var(--text-muted)" }}>
          {quotesCount != null ? `${quotesCount} quotes` : ""}
        </span>
        <Button variant="primary" size="sm" iconRight="arrow-right" onClick={onAction}>{ctaLabel}</Button>
      </div>
    </Card>
  );
}
